import { BaseEntity } from './base.entity';

export class Project extends BaseEntity {
  id: string;
  name: string;
  description: string | null;
  invite_code: string;
  created_at: Date;
  updated_at: Date;
  created_by_id: string;
  onboarding_completed_at: Date | null;

  constructor(data: {
    id: string;
    name: string;
    description: string | null;
    invite_code: string;
    created_at: Date;
    updated_at: Date;
    created_by_id: string;
    onboarding_completed_at?: Date | null;
  }) {
    super();
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.invite_code = data.invite_code;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.created_by_id = data.created_by_id;
    this.onboarding_completed_at = data.onboarding_completed_at || null;
    this.setOriginalData(this.toData());
  }

  /**
   * Update project information
   */
  updateInfo(name: string, description: string | null): void {
    this.name = name;
    this.description = description;
    this.updated_at = new Date();
    this.markAsDirty();
  }

  /**
   * Regenerate invite code
   */
  regenerateInviteCode(newCode: string): void {
    this.invite_code = newCode;
    this.updated_at = new Date();
    this.markAsDirty();
  }

  /**
   * Update onboarding completion timestamp
   */
  updateOnboardingStatus(completedAt: Date | null): void {
    this.onboarding_completed_at = completedAt;
    this.updated_at = new Date();
    this.markAsDirty();
  }

  /**
   * Convert to plain data object
   */
  toData(): any {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      invite_code: this.invite_code,
      created_at: this.created_at,
      updated_at: this.updated_at,
      created_by_id: this.created_by_id,
      onboarding_completed_at: this.onboarding_completed_at
    };
  }

  /**
   * Create Project instance from database row
   */
  static fromData(data: any): Project {
    return new Project({
      id: data.id,
      name: data.name,
      description: data.description,
      invite_code: data.invite_code,
      created_at: new Date(data.created_at),
      updated_at: new Date(data.updated_at),
      created_by_id: data.created_by_id,
      onboarding_completed_at: data.onboarding_completed_at ? new Date(data.onboarding_completed_at) : null
    });
  }
}

export interface ProjectInsert {
  name: string;
  description?: string | null;
  invite_code?: string; // 서비스에서 자동 생성
  created_by_id: string;
}

export interface ProjectUpdate {
  name?: string;
  description?: string | null;
  invite_code?: string; // 초대 코드 재생성 가능
}